import { useData } from "../../hooks/useData";
import Counter from "../ui-custom/Counter";
import { Reveal } from "../ui-custom/Reveal";

export default function Stats() {
  const { data } = useData("statistics");
  if (!data) return null;

  return (
    <section className="relative mx-auto max-w-7xl px-5 py-16" data-testid="stats-section">
      <div className="grid grid-cols-2 gap-4 rounded-3xl glass p-8 lg:grid-cols-4 lg:p-10">
        {data.items.map((s, i) => (
          <Reveal key={i} delay={i * 0.1} className="text-center">
            <div className="text-4xl font-bold text-gradient sm:text-5xl" data-testid={`stat-value-${i}`}>
              <Counter value={s.value} suffix={s.suffix} decimals={s.decimals || 0} />
            </div>
            <p className="mt-2 text-sm text-slate-500">{s.label}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
